// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Js_exn from "../../../../../../node_modules/rescript/lib/es6/js_exn.js";
import * as Caml_array from "../../../../../../node_modules/rescript/lib/es6/caml_array.js";
import * as Router from "next/router";
import * as Caml_js_exceptions from "../../../../../../node_modules/rescript/lib/es6/caml_js_exceptions.js";
import * as Config$PorterinUtils from "../../../../../../node_modules/@porterin/utils/src/configs/Config.mjs";
import * as FaqsCmp$PorterinFeature from "../../../ui/components/FaqsCmp.mjs";
import * as HomeHelper$PorterinFeature from "../domain/helper/HomeHelper.mjs";
import * as CityContext$PorterinFeature from "../../../contexts/city-context/CityContext.mjs";
import * as HomeStoreEn$PorterinFeature from "../domain/store/HomeStoreEn.mjs";
import * as Lib$PorterinFusionkitSentry from "../../../../../../node_modules/@porterin/fusionkit-sentry/src/Lib.mjs";
import * as HomeVMMapper$PorterinFeature from "./view-model/HomeVMMapper.mjs";
import * as LoadingSpinner$PorterinFeature from "../../../ui/components/LoadingSpinner.mjs";
import * as MiddleSectionCmp$PorterinFeature from "./components/MiddleSectionCmp.mjs";
import * as CategoryAnalytics$PorterinFeature from "../../fare-estimate-v1/domain/helpers/CategoryAnalytics.mjs";
import * as HomeContainerModuleScss from "./styles/HomeContainer.module.scss";
import * as ServicesSectionCmp$PorterinFeature from "./components/ServicesSectionCmp.mjs";
import * as EnterpriseBannerCmp$PorterinFeature from "./components/EnterpriseBannerCmp.mjs";
import * as ServicesCategoryCmp$PorterinFeature from "./components/ServicesCategoryCmp.mjs";
import * as HomeBannerWrapperCmp$PorterinFeature from "./components/HomeBannerWrapperCmp.mjs";
import * as CommonAnalyticsHelper$PorterinFeature from "../../../shared/core/helpers/CommonAnalyticsHelper.mjs";
import * as DownloadAppSectionCmp$PorterinFeature from "../../../shared/download-app/view/components/DownloadAppSectionCmp.mjs";
import * as EnterpriseGrowthCardCmp$PorterinFeature from "./components/EnterpriseGrowthCardCmp.mjs";

var styles = HomeContainerModuleScss;

function HomeContainer(Props) {
  var page_data = Props.page_data;
  var fare_estimate_form_content = Props.fare_estimate_form_content;
  var router = Router.useRouter();
  var citySelectedContext = CityContext$PorterinFeature.useCitySelectedContext(undefined);
  var match = React.useState(function () {
        
      });
  var cities = page_data.cities;
  var setCityServices = match[1];
  var cityServices = match[0];
  var match$1 = React.useState(function () {
        return false;
      });
  var setIsEnterpriseV2Enabled = match$1[1];
  var isEnterpriseV2Enabled = match$1[0];
  var match$2 = React.useState(function () {
        if (Config$PorterinUtils.enable_enterprise_nudge !== undefined) {
          return Config$PorterinUtils.enable_enterprise_nudge;
        } else {
          return false;
        }
      });
  var setIsLoading = match$2[1];
  var isLoading = match$2[0];
  React.useEffect((function () {
          var timeout_id = setTimeout((function (param) {
                  CommonAnalyticsHelper$PorterinFeature.publishPageLandEvent(CategoryAnalytics$PorterinFeature.getCategoryName(router), HomeStoreEn$PorterinFeature.ga_page_landing);
                }), 0);
          return (function (param) {
                    clearTimeout(timeout_id);
                  });
        }), []);
  React.useEffect((function () {
          var city = citySelectedContext.city_selected;
          if (city !== undefined) {
            try {
              Curry._1(setCityServices, (function (param) {
                      return HomeVMMapper$PorterinFeature.getCurrentCityData(cities, city);
                    }));
            }
            catch (raw_exn){
              var exn = Caml_js_exceptions.internalToOCamlException(raw_exn);
              if (exn.RE_EXN_ID === Js_exn.$$Error) {
                Curry._1(Lib$PorterinFusionkitSentry.React.captureMessage, "Home Local Storage: Error finding city: " + city);
              } else {
                throw exn;
              }
            }
          } else {
            var city$1 = Caml_array.get(cities, 0);
            Curry._2(citySelectedContext.set_city_selected, city$1.city_name, city$1.city_label);
          }
        }), [
        citySelectedContext.city_selected,
        router.locale
      ]);
  React.useLayoutEffect((function () {
          try {
            if (Config$PorterinUtils.enable_enterprise_nudge !== undefined && Config$PorterinUtils.enable_enterprise_nudge) {
              var rolloutValue = HomeHelper$PorterinFeature.getIsContainsVisitorId(0);
              Curry._1(setIsEnterpriseV2Enabled, (function (param) {
                      return rolloutValue;
                    }));
            }
            
          }
          catch (exn){
            Curry._1(setIsLoading, (function (param) {
                    return false;
                  }));
          }
          Curry._1(setIsLoading, (function (param) {
                  return false;
                }));
        }), []);
  return React.createElement(React.Fragment, undefined, React.createElement(HomeBannerWrapperCmp$PorterinFeature.make, {
                  data: page_data,
                  is_enterprise_v2_enabled: isEnterpriseV2Enabled,
                  is_loading: isLoading
                }), React.createElement(ServicesCategoryCmp$PorterinFeature.make, {
                  city_selector_data: cities,
                  city_selected: cityServices,
                  fare_estimate_form_content: fare_estimate_form_content,
                  content: page_data,
                  is_enterprise_v2_enabled: isEnterpriseV2Enabled
                }), React.createElement("div", {
                  className: styles["mobile-only"]
                }, React.createElement(EnterpriseBannerCmp$PorterinFeature.make, {
                      is_loading: isLoading,
                      link: page_data.enterprise_home_section.cta.href,
                      is_enterprise_v2_enabled: isEnterpriseV2Enabled,
                      page_data: page_data
                    })), React.createElement("div", {
                  className: styles["desktop-only"]
                }, React.createElement(EnterpriseGrowthCardCmp$PorterinFeature.make, {
                      section_data: page_data.enterprise_home_section
                    })), cityServices !== undefined ? React.createElement(ServicesSectionCmp$PorterinFeature.make, {
                    services_cards_data: cityServices.city_services_promo,
                    wave_icon: page_data.icons.wave_icon,
                    title: page_data.service_title
                  }) : React.createElement("div", {
                    className: styles["section-loading"]
                  }, React.createElement(LoadingSpinner$PorterinFeature.make, {})), React.createElement(DownloadAppSectionCmp$PorterinFeature.make, {
                  data: page_data.download_app_mobile
                }), React.createElement(MiddleSectionCmp$PorterinFeature.make, {
                  data: page_data
                }), React.createElement(FaqsCmp$PorterinFeature.make, {
                  faqs_section: page_data.faqs
                }));
}

var make = HomeContainer;

var $$default = HomeContainer;

export {
  styles ,
  make ,
  $$default ,
  $$default as default,
}
/* styles Not a pure module */
